import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'spire-enrollment-modal:title': {
    id: 'spire-enrollment-modal:title',
    defaultMessage: 'Spire',
    description: 'Title for Spire enrollment modal',
  },
  'spire-enrollment-modal:description': {
    id: 'spire-enrollment-modal:description',
    defaultMessage: 'Add Spire for easy bank-linked payments',
    description: 'Description for Spire enrollment modal (first-time / not previously completed)',
  },
  'spire-enrollment-modal:incomplete-enrollment-description': {
    id: 'spire-enrollment-modal:incomplete-enrollment-description',
    defaultMessage:
      'Your Spire enrollment was not completed. Complete your enrollment now to start using Spire for lower-cost payments and extra rewards.',
    description: 'Description for incomplete Spire enrollment modal',
  },
  'spire-enrollment-modal:button-add-spire': {
    id: 'spire-enrollment-modal:button-add-spire',
    defaultMessage: 'Add Spire',
    description: 'Button text to add/enroll in Spire',
  },
  'spire-enrollment-modal:button-maybe-later': {
    id: 'spire-enrollment-modal:button-maybe-later',
    defaultMessage: 'Maybe Later',
    description: 'Button text to dismiss the modal',
  },
  'spire-enrollment-modal:error-not-available': {
    id: 'spire-enrollment-modal:error-not-available',
    defaultMessage: 'Spire is not currently available.',
    description: 'Error message when Spire feature flag is disabled',
  },
});
